export const pluralFormat = (value: number, unit: string) =>
  [value, ...unit.split(' ').map(u => (value > 1 ? `${u}s` : u))].join(' ');
